const locale = "en";

export function createSiteUrl(path = "", subdomain) {
	const siteDomain = process.env.VUE_APP_SITE_PATH
	const baseHost = subdomain ? `${subdomain}.${siteDomain}` : siteDomain;
	const url = new URL(`https://${baseHost}/`);
	url.pathname = path;

	return url.toString()
}

export function createHelpCenterUrl(articleId) {
	let articlePath = locale;
	if (articleId) {
		articlePath += `/articles/${articleId}`
	}
	return createSiteUrl(articlePath, "help");
}
